import { createSelector } from 'reselect';


export function getRoomBrowse(state) {
  return state.roomBrowse
}

export function getRoomList(state) {
  return getRoomBrowse(state).list
}

export function getRoomBrowseFilter(state) {
  return getRoomBrowse(state).filter
}

export function getBuildingSelection(state) {
  return getRoomBrowse(state).buildingSelection
}
//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getVisibleRooms = createSelector(
  getRoomList,
  getRoomBrowseFilter,
  (rooms, filter) => {
    return rooms.filter(function(room) {
      return room.capacity === filter
    })
  }
)


// WEBPACK FOOTER //
// ./src/core/room-browse/selectors.js